import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/customers')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('customers:list')) {
      throw redirect({ to: '/' });
    }
  },
  component: lazyRouteComponent(() =>
    import('&/features/customers/pages/customers-page').then((m) => ({ default: m.CustomersPage })),
  ),
});
